const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}
const DepositChild = {
  path: '/deposit',
  component: _import('SaveMonery'),
  children: [{
      path: '',
      meta: {
        navShow: true,
        titleHide: true,
        diffBg2: true,
        requireAuth: true,
        isContact: true, // 底部联系方式
        title: '存款'
      },
      name: 'saveMonery',
      component: _import('SaveMonery/Base'),
      children: [
        {
            path: '/deposit/with/:id',
            name: 'depositWithUPI',
            meta: { navShow: false, titleHide: true,requireAuth:true,title: 'UPI'},
            component: () => import('../../views/SaveMonery/UPI.vue')
        },
        // {
        //     path: '/deposit/with/UPI',
        //     name: 'depositWithUPI',
        //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'UPI'},
        //     component: () => import('../../views/SaveMonery/UPI.vue')
        // },
        // {
        //     path: '/deposit/with/PHONEPE',
        //     name: 'depositWithPHONEPE',
        //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'PHONEPE'},
        //     component: () => import('../../views/SaveMonery/PHONEPE.vue')
        // },
        // {
        //     path: '/deposit/with/PAYTM',
        //     name: 'depositWithPAYTM',
        //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'PAYTM'},
        //     component: () => import('../../views/SaveMonery/PAYTM.vue')
        // },
        // {
        //     path: '/deposit/with/GPAY',
        //     name: 'depositWithGPAY',
        //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'GPAY'},
        //     component: () => import('../../views/SaveMonery/GPAY.vue')
        // },
        {
          path: '/deposit/USDT',
          name: 'depositUSDT',
          meta: { navShow: false, titleHide: true,requireAuth:true,title: 'USDT'},
          component: () => import('../../views/SaveMonery/USDT.vue')
        },
        {
          path: '/deposit/ONLINE',
          name: 'depositONLINE',
          meta: { navShow: false, titleHide: true,requireAuth:true,title: 'ONLINE'},
          component: () => import('../../views/SaveMonery/ONLINE.vue')
        },
         // 极速存款
        {
          path: '/deposit/FASTPAY',
          name: 'depositFASTPAY',
          meta: { navShow: false, titleHide: true,requireAuth:true,title: 'FASTPAY'},
          component: () => import('../../views/SaveMonery/fast/index.vue')
        },        
        {
          path: '/deposit/OFFLINE',
          name: 'depositOFFLINE',
          meta: { navShow: false, titleHide: true,requireAuth:true,title: 'OFFLINE'},
          component: () => import('../../views/SaveMonery/OFFLINE.vue')
        },
        {
          path: '/deposit/OFFLINEBANK',
          name: 'depositAdd3',
          meta: { navShow: false, titleHide: true,requireAuth:false,title: 'ADD3'},
          component: () => import('../../views/SaveMonery/depositAdd3.vue')
        },
        {
          path: '/deposit/SEMI',
          name: 'depositSEMI',
          meta: { navShow: false, titleHide: true,requireAuth:true,title: 'SEMI'},
          component: () => import('../../views/SaveMonery/SEMI.vue')
        },
        {
          path: '/deposit/SEMIBANK',
          name: 'depositAdd2',
          meta: { navShow: false, titleHide: true,requireAuth:false,title: 'ADD2'},
          component: () => import('../../views/SaveMonery/depositAdd2.vue')
        },
        {
          path: '/deposit/add',
          name: 'depositAdd',
          meta: { navShow: false, titleHide: true,requireAuth:false,title: 'ADD'},
          component: () => import('../../views/SaveMonery/depositAdd.vue')
        },
        {
          path: '/deposit/summary',
          name: 'depositSummary',
          meta: { navShow: false, titleHide: true,requireAuth:false,title: 'summary'},
          component: () => import('../../views/SaveMonery/summary.vue')
        },
      ]
    },
    {
      path: 'BankTransfer',
      meta: {
        navShow: false,
        titleHide: true,
        title: '银行汇款'
      },
      name: 'BankTransfer',
      component: _import('SaveMonery/BankTransfer'),
    },
    {
      path: 'otherTransfer',
      meta: {
        navShow: false,
        titleHide: true,
        title: 'otherTransfer'
      },
      name: 'otherTransfer',
      component: _import('SaveMonery/otherTransfer'),
    },
    {
      path: 'recharge',
      meta: {
        navShow: false,
        titleHide: true,
        title: 'Recharge'
      },
      name: 'Recharge',
      component: _import('SaveMonery/Recharge'),
    },
    // {
    //     path: '/deposit/with/PHONEPE',
    //     name: 'depositWithPHONEPE',
    //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'PHONEPE'},
    //     component: () => import('../../views/SaveMonery/depositWithPHONEPE.vue')
    // },
    // {
    //     path: '/deposit/with/PAYTM',
    //     name: 'depositWithPAYTM',
    //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'PAYTM'},
    //     component: () => import('../../views/SaveMonery/depositWithPAYTM.vue')
    // },
    // {
    //     path: '/deposit/with/GPAY',
    //     name: 'depositWithGPAY',
    //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'GPAY'},
    //     component: () => import('../../views/SaveMonery/depositWithGPAY.vue')
    // },
    // {
    //     path: '/deposit/with/UPI',
    //     name: 'depositWithUPI',
    //     meta: { navShow: false, titleHide: true,requireAuth:true,title: 'UPI'},
    //     // component: () => import('../../views/SaveMonery/depositWithUPI.vue')
    //     component: () => import('../../views/SaveMonery/UPI.vue')
    // },
  ]
}

export default DepositChild



// WEBPACK FOOTER //
// ./src/pages/build821/router/module/Deposit.js